import api from "./api";

function countryHeaders() {
  const code = (
    import.meta.env.VITE_COUNTRY_CODE ||
    String(import.meta.env.VITE_BASE_PATH || '/br').replace(/^\//, '') ||
    'br'
  )
    .toLowerCase()
    .trim();
  return { 'x-country-code': code || 'br' };
}

class MembersService {
  update(memberId, body) {
    return api.put(`v2/api/members/${memberId}`, body)
  }

  updateMemberAvatar(memberId, body) {
    return api.put(`v2/api/members/${memberId}/avatar`, body)
  }

  acceptRegulation(body){
    return api.post(`v2/api/members/accept-regulation`, body)
  }

  sendMemberGetMemberInvite(email) {
    return api.post(
      `v2/api/members/member-get-member-invite`,
      { email },
      { headers: countryHeaders() }
    );
  }

  getMemberGetMember() {
    return api.get(`v2/api/members/member-get-member`, { headers: countryHeaders() });
  }
}

export default new MembersService();